const config = {
  environment: 'qa',
  redirect_url: 'https://qa.hotglue.io/callback',
  api_url: 'https://mb43blqb8j.execute-api.us-east-1.amazonaws.com/api',
};

export default config;
